<template>
  <div>
    <!-- Using null to indicate loading state -->
    <BSpinner
      v-if="loadingTransactions === true"
      label="Loading transactions..."
    ></BSpinner>
    <div
      v-else-if="transactions && transactions.length === 0"
      class="text-center text-muted"
    >
      <IconAlertTriangle class="me-1 text-warning" />
      <br />
      No transactions found.
    </div>
    <div class="row" v-else>
      <div class="col-md-8 col-sm-12 col-12">
        <ListItemView
          v-for="txn in sortedTransactions"
          :key="txn.transaction_uid"
          :txn="txn"
          @deleteTransaction="$emit('deleteTransaction', $event)"
        />
      </div>
      <div
        v-if="userInfo?.username === 'javesparza'"
        class="col-md-4 col-sm-12 col-12"
      >
        <PendingActionsIndexView :acctUid="acctUid" />
      </div>
    </div>
  </div>
</template>
<script>
import { IconAlertTriangle } from "@tabler/icons-vue";
import ListItemView from "@/components/Transactions/ListItemView.vue";
import { BSpinner } from "bootstrap-vue-next";
import numberFormatMixin from "@/mixins/numberFormatMixin";
import PendingActionsIndexView from "@/components/PendingActions/IndexView.vue";
import { userSession as userSessionNS } from "@/store/namespaces";

export default {
  name: "TransactionsListView",
  props: {
    acctUid: {
      type: String,
      required: true,
    },
    transactions: {
      type: Array,
      default: null,
    },
    loadingTransactions: {
      type: Boolean,
      default: false,
    },
    trsxnsStartDate: {
      type: String,
      default: null,
    },
    trsxnsEndDate: {
      type: String,
      default: null,
    },
  },
  emits: ["deleteTransaction"],
  mixins: [numberFormatMixin],
  components: {
    BSpinner,
    IconAlertTriangle,
    ListItemView,
    PendingActionsIndexView,
  },
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters[`${userSessionNS}/getUserInfo`];
    },
    sortedTransactions() {
      if (!this.transactions) return null;

      const dateSorted = this.transactions.slice().sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });

      // Next, if a transaction has `snapshot_categories`, we want to place those last, since those are the ones that have been categorized
      return dateSorted.sort((a, b) => {
        if (a.snapshot_categories && !b.snapshot_categories) {
          return 1; // a should come after b
        } else if (!a.snapshot_categories && b.snapshot_categories) {
          return -1; // a should come before b
        } else {
          return 0; // maintain original order
        }
      });
    },
  },
};
</script>
